// @file Native Bridge Legacy

import { listen } from '@@/native_bridge/listen'
import * as stateActions from '@@/native_bridge/native_actions_map'
import { ActionableStore, NativeBridgeWindow } from '@@/native_bridge/types'

function buildLegacyNativeBridge({ document }, { dispatch }) {
  const callbacks: { [key: string]: Function | null } = {}

  /*************************************
   * NATIVE BRIDGE METHODS
   *************************************/

  // TODO: Deprecate
  // Used in mobile app
  const createPostWithMedia = (options: { url?: string } = {}) =>
    options.url &&
    dispatch('post/createPost', {
      attributes: {
        attachment: options.url,
        wish_content: {
          attachment_props: {
            url: options.url,
          },
          is_processed: false,
        },
      },
    })
  const nonRegisterable = {
    createPostWithMedia,
  }

  /*************************************
   * BUILD HASH
   *************************************/
  const register = {}
  const deregister = {}
  const trigger = { ...nonRegisterable }

  // This mirrors what used to be window.$nativeBridge.dispatch(), declared in native_bridge/install.ts
  // In case window.$nativeBridge gets deprecated, this instance of dispatch can replace it.
  const nativeBridgeDispatch = (fnName: string, ...args: any[]): void => {
    const actions = stateActions[fnName]
    // Do an early return if the actions are undefined since they are likely unsupported anymore due to old mobile app versions.
    if (actions === undefined) return
    dispatch(actions.apply(null, args))
  }

  return { dispatch: nativeBridgeDispatch, register, deregister, trigger }
}

function initializeListeners({ store: { dispatch } }) {
  // MOBILE APPS: 20 <= VERSION <= 90 (Jul 2019: native settings panel)
  listen('create_post', (attributes) => dispatch('post/createPost', { attributes }))
  listen('padlet_settings_hide', () => dispatch('settings/hideSettingsPanel'))
  listen('padlet_settings_update', (msg: any) =>
    dispatch('settings/updateAndValidatePreviewAttributes', { ...msg.preview_attributes }),
  )
}

export default function install(window: NativeBridgeWindow, store: ActionableStore) {
  if (!window.ww) window.ww = {}
  window.ww.nativeBridge = { ...window.ww.nativeBridge, ...buildLegacyNativeBridge(window, store) }
  initializeListeners({ store })
}
